/**
 * 404 token view
 */
import React from 'react';

// Translation
import translate from '../../translate/Translate';

// Icons
import * as icons from '../../ui/Icons';

import { getParam } from '../../../helpers';

const ErrorConfig = class ErrorConfig extends React.Component {
  componentDidMount() {
    const { UserStore } = this.props.store;

    UserStore.resetUserData();
  }

  handleErrorMsg() {
    const { store, translation } = this.props;
    const { UserStore } = store;
    const error = getParam('error');

    let errorMsg = '';

    switch(error) {
      case 'domainNotFound':
        errorMsg = translation.error_details[error].replace('%domain%', window.location.origin);
        break;
      case 'pageNotConfigured':
        errorMsg = translation.error_details[error];
        break;
      default:
        errorMsg = translation.error_details[UserStore.signOnError];
    }

    return errorMsg;
  }

  render() {
    const { translation } = this.props;

    return (
      <main
        id="main-content"
        className="page wrap"
        tabIndex="-1"
        aria-labelledby="page-title"
      >
        <div className="panel panel--sm panel--solo">
          <i className="panel__icon">
            <icons.lock />
          </i>

          <h1 id="page-title" className="panel__title">
            {translation.heading}
          </h1>

          <code className="code-block">
            {this.handleErrorMsg()}
          </code>
        </div>
      </main>
    );
  }
};

export default translate('ErrorConfig')(ErrorConfig);
